export default __webpack_public_path__ + "images/51_2_image.jpg";